import { getBlobUrl } from '../../../../../helpers/getBlobUrl';
import { getAttachmentNameWithExtension } from '../../../../../helpers/getAttachmentNameWithExtension';
import useDocByName from '../api/useDocByName';

const useGetDocUrl = () => {
  const { mutateAsync } = useDocByName();

  const getAttachmentUrl =
    ({ permitId }) =>
    async (data) => {
      const fileName =
        typeof data === 'string'
          ? data
          : getAttachmentNameWithExtension(data) || data?.fileName;

      if (!fileName) return null;

      const fileExtension = fileName.split('.').pop();

      const attachData = await mutateAsync({
        permitId,
        fileName,
      });

      if (!attachData || attachData === 'Error') return null;

      const url = getBlobUrl(attachData, fileExtension);

      return url;
    };

  return getAttachmentUrl;
};

export default useGetDocUrl;
